module.exports = __webpack_public_path__ + "img/25km²-1.0a78a20b.png";